import { CustomMainContent } from "../../components";
import { useState } from "react";
import { PrincipalHeader } from "../VrLearning/templates/PrincipalHeader";
import { HelpButtonsTraining } from "./templates/HelperButtonsTraining";
// import { TrainingMainContent } from "./templates/TrainingMainContent";
import { TrainingContentVT } from "./templates/TemplatesVersionTwo/TrainingContentVT";


const TrainingTable = () => {
    const [hasFilter, setHasFilter] = useState(false);
    const [dateRange, setDataRange] = useState(null);

    return (
        <CustomMainContent>
            <div className="flex h-full w-full min-w-[800px]  ">
                <div className="w-100-68  h-full flex flex-col gap-4 ">
                    <div className="w-full h-14 shadow-md bg-white rounded-xl">
                        <PrincipalHeader
                            hasFilter={hasFilter}
                            setFilter={(value) => setHasFilter(value)}
                            dateRange={dateRange}
                            setDataRange={setDataRange}
                        />
                    </div>
                    {/* <div className="w-full h-100-56   bg-white rounded-xl z-20 shadow-md ">
                        <TrainingMainContent dateRange={dateRange} hasFilter={hasFilter} />
                    </div> */}
                    <div className="w-full h-100-56 bg-white rounded-xl z-20 shadow-md ">
                        <TrainingContentVT dateRange={dateRange} hasFilter={hasFilter}></TrainingContentVT>
                    </div>

                </div>
                <div className="w-[68px] h-full flex justify-center">
                    <HelpButtonsTraining />
                </div>
            </div>
        </CustomMainContent>
    );
};

export default TrainingTable;
